import { Type } from 'class-transformer';
import { Subsidiary } from '../subsidiary/subsidiary';

export class ForecastDetail {
    public readonly id!: string;
    public readonly requestedQuantity!: number;
    public readonly allocatedQuantity!: number;

    @Type(() => Subsidiary)
    public readonly subsidiary!: Subsidiary;
}
